import { AnyAction } from 'typescript-fsa';
import { createEpicMiddleware } from 'redux-observable';
import { applyMiddleware, compose, createStore } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import Cookies from 'universal-cookie';
import SearchAnswers from '../search/SearchAnswers';
import rootReducer, { rootEpic, RootState } from './features/index';

export const makeStore = () => {
  const answers = new SearchAnswers(new Cookies());
  const epicMiddleware = createEpicMiddleware<AnyAction, AnyAction, RootState>({
    dependencies: { answers: answers }
  });

  const composeEnhancers =
    (typeof window !== 'undefined' &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(epicMiddleware))
  );
  epicMiddleware.run(rootEpic);
  return store;
};

export const wrapper = createWrapper(makeStore);
